import { useState } from 'react'
import { useQuery, useInfiniteQuery } from 'react-query'
import { useRouter } from 'next/router'

// Libs
import { fetchCategoryFilter } from '@/api/fetchCategoryFilter'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { MALL_DEFAULT_PAGE_SIZE } from '@/constants/mall'

// Types

interface IParams {
  defaultPayload?: {
    pageSize: number
    categoryId: any
  }
  fetchDataApi: any
  merchantId?: number
  testMode?: string
}

const defaultCategoryList = { pageSize: MALL_DEFAULT_PAGE_SIZE, categoryId: null }

// FIXME:
// 這個 hook 要重構
// 當初和逛逛頁，使用同一個 useMallList hook，但是其實產品邏輯不一樣，不能共用
// 目前先用先前的 code，但是要重構
export const useProductContentList = ({ defaultPayload = defaultCategoryList, fetchDataApi, merchantId, testMode }: IParams) => {
  const [categoryListPayload, setCategoryListPayload] = useState(defaultPayload)

  const router = useRouter()

  const categoryFilter = useQuery([QUERY_KEY.FETCH_CATEGORY_FILTER, { testMode }], () => fetchCategoryFilter({ testMode }), {})

  const defaultCategoryId = categoryFilter?.data?.list[0].categoryId

  const { pageSize } = categoryListPayload

  const categoryListData = useInfiniteQuery(
    [QUERY_KEY.FETCH_CATEGORY_LIST, { categoryId: defaultCategoryId, merchantId }],
    ({ pageParam }) =>
      fetchDataApi({
        categoryId: defaultCategoryId,
        pageSize,
        pageNo: pageParam,
        merchantId: merchantId || '',
      }),
    {
      enabled:
        categoryFilter?.isFetched && categoryFilter?.isSuccess && defaultCategoryId !== null && router.isReady && defaultCategoryId !== undefined,
      getNextPageParam: (lastPage, pages) => {
        if (!router.isReady) return undefined

        const currentPage = pages?.length || 1
        const totalPage = lastPage?.totalPage?.totalPages || 0
        let result: number | undefined = 0
        const allPageData = JSON.stringify({ data: pages })
        const emptyPageDataIdentifier = '"productsInfo":null'

        if (allPageData.includes(emptyPageDataIdentifier)) {
          result = undefined
          return
        }

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          const isLastPage = currentPage === totalPage
          result = isLastPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  )

  return { categoryListData, categoryListPayload, setCategoryListPayload, categoryFilter }
}
